angular.module('impactx.checkboxgroup', []);